import React from 'react';
import { motion } from 'framer-motion';
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'outline' | 'ghost';
  size?: 'sm' | 'md' | 'lg';
  children: React.ReactNode;
  className?: string;
}
export function Button({
  variant = 'primary',
  size = 'md',
  children,
  className = '',
  ...props
}: ButtonProps) {
  const baseStyles = 'inline-flex items-center justify-center rounded-full font-body font-medium transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-hubble-signal focus:ring-offset-2 focus:ring-offset-hubble-ink';
  const variants = {
    primary: 'bg-hubble-signal text-white hover:opacity-90',
    outline: 'border border-hubble-signal text-hubble-signal hover:bg-hubble-signal/10',
    ghost: 'text-hubble-paper/70 hover:text-hubble-paper hover:bg-hubble-paper/5'
  };
  const sizes = {
    sm: 'px-4 py-2 text-sm',
    md: 'px-6 py-3 text-base',
    lg: 'px-8 py-4 text-lg'
  };
  return <motion.button whileHover={{
    scale: 1.02
  }} whileTap={{
    scale: 0.98
  }} className={`${baseStyles} ${variants[variant]} ${sizes[size]} ${className}`} {...props} data-id="element-209">
      {children}
    </motion.button>;
}